export default "__VITE_PUBLIC_ASSET__5e61313e__"